"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var index_1 = require("./index");

var OfflineProductStorage =
/*#__PURE__*/
function () {
  function OfflineProductStorage(id) {
    _classCallCheck(this, OfflineProductStorage);

    this.id = id;
  }

  _createClass(OfflineProductStorage, null, [{
    key: "create",
    value: function create(productPayload) {
      if (productPayload instanceof Object && 'storage_id' in productPayload) {
        return new OfflineProductStorage(productPayload.storage_id);
      } else {
        throw new index_1.TwilsockError('Field "storage_id" is missing');
      }
    }
  }]);

  return OfflineProductStorage;
}();

exports.OfflineProductStorage = OfflineProductStorage;